import { useQuery } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth';
import fetchUsersData from '../Services/fetchUsersData';

export default function useUsersData() {
	const { accessToken } = useAuth();

	const usersQuery = useQuery({
		queryKey: ['users'],
		queryFn: () => fetchUsersData(accessToken),
		staleTime: Infinity,
		retry: false,
	});

	return usersQuery;
}
